import * as React from "react";

import { Screen } from "@v2/features/account/common";
import useCurrentUser from "@v2/hooks/useCurrentUser";
import { useDocumentTitle } from "@v2/hooks/useDocumentTitle";
import { Navigate, useLocation } from "react-router-dom";

import { getAuthRedirectPath } from "./authRedirect";

const AuthenticatedUserRequiredRoute: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { isAuthenticated, isLoading } = useCurrentUser();
  const { pathname, search } = useLocation();
  const isEditorRoute = pathname.startsWith("/editor/");

  // Set "Dashboard" title for non-editor routes (editor routes set their own title)
  useDocumentTitle(isEditorRoute ? null : "Dashboard");

  if (!isAuthenticated && !isLoading) {
    return (
      <Navigate
        to={getAuthRedirectPath({
          authPath: Screen.SIGNUP,
          pathname,
          search,
        })}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default AuthenticatedUserRequiredRoute;
